import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

export const translationResolver: ResolveFn<void> = () => {
  const translate = inject(TranslateService);
  const lang = localStorage.getItem('selectedLanguage') || 'it';
  return firstValueFrom(translate.use(lang)).then(() => undefined);
};
